import * as React from 'react'

function SvgIconDocumentZip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="document-zip" aria-labelledby="t-document-zip d-document-zip">
        <title id="t-document-zip">{'Zipped document'}</title>
        <desc id="d-document-zip">{'A paper sheet with a zipper'}</desc>
        <path d="M10 27v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1zm3 2h-2v-2h2v2z" />
        <path d="M12 21c-2.2 0-4 1.8-4 4v4c0 1.7 1.3 3 3 3h2c1.7 0 3-1.3 3-3v-4c0-2.2-1.8-4-4-4zm3 8c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-4c0-1.7 1.3-3 3-3s3 1.3 3 3v4zm-5-15.5c0 .3.2.5.5.5H12v-1h-1.5c-.3 0-.5.2-.5.5zm0-3c0 .3.2.5.5.5H12v-1h-1.5c-.3 0-.5.2-.5.5zm3.5 4.5H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM10 16.5c0 .3.2.5.5.5H12v-1h-1.5c-.3 0-.5.2-.5.5zm0 3c0 .3.2.5.5.5H12v-1h-1.5c-.3 0-.5.2-.5.5zm3.5-1.5H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0-6H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM10 4.5c0 .3.2.5.5.5H12V4h-1.5c-.3 0-.5.2-.5.5zM13.5 3H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0 6H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM10 7.5c0 .3.2.5.5.5H12V7h-1.5c-.3 0-.5.2-.5.5zM13.5 6H12v1h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z" />
        <path d="M19 0H5v32h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H6V1h4.5c-.3 0-.5.2-.5.5s.2.5.5.5H12V1h6v7c0 .6.4 1 1 1h7v22h-8.5c-.3 0-.5.2-.5.5s.2.5.5.5H27V8l-8-8zm0 8V1.4L25.6 8H19z" />
      </g>
    </svg>
  )
}

export default SvgIconDocumentZip
